<template>
  <div>
    <span v-if="countdown != 0">{{remoteTime | formateTime(countdown) | timeFactory}}</span>
  </div>
</template>

<script>
import { get } from '@/utils/ajax'
export default {
  name: 'Countdown',
  props: {
    remoteTime: Number
  },
  data() {
    return {
      countdown: 0,
      originTime: 0
    }
  },
  filters: {
    // 页面倒计时
    formateTime (value, countdown) {
      const time = value - countdown
      return time
    },
    // 倒计时格式化
    timeFactory (timestamp) {
      if (timestamp < 0) {
        return '00 : 00 : 00'
      }
      timestamp = timestamp / 1000
      // let d = parseInt(timestamp / (24 * 60 * 60))
      let h = Math.floor(timestamp / 3600)
      let m = Math.floor(timestamp / 60 % 60)
      let s = Math.floor(timestamp % 60)
      // d = d < 10 ? 0 + '' + d : d
      h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return h + ' : ' + m + ' : ' + s
    }
  },
  async mounted () {
    const time = await get('/home/common/times')
    this.$emit('listen', time)
    this.countdown = time
    this.originTime = time
    const time1 = +Date.now()
    this.timer = setInterval(() => {
      const time2 = +Date.now()
      const accuracy = time2 - time1
      this.startTime(accuracy)
    }, 1000)
  },
  methods: {
    startTime (accuracy) {
      this.countdown = this.originTime + accuracy
      this.$emit('listen', this.originTime + accuracy)
    }
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
